import type { SignalLinkedFindingPreviewDto } from '@terra/shared-contracts-findings';
import type { LinkedFindingRowData } from '@terra/ui-design-system';
import { isArchivedEntity } from '@terra/shared-dto-types';

export type RelatedFindingForSignal = {
  id: string;
  signalId: string | null;
  title?: string | null;
  shortDescription?: string | null;
  status?: string | null;
  severity?: string | null;
  createdAt?: string | Date;
  discoveryDate?: string | Date | null;
  lifecycle?: { state: string } | null;
};

export function relatedFindingFromSignalLinkedPreview({
  signalId,
  linkedFinding,
}: {
  signalId: string;
  linkedFinding: SignalLinkedFindingPreviewDto;
}): RelatedFindingForSignal {
  return {
    id: linkedFinding.id,
    signalId,
    title: linkedFinding.title,
    shortDescription: linkedFinding.shortDescription ?? null,
    status: linkedFinding.status,
    severity: linkedFinding.severity,
    createdAt: linkedFinding.createdAt,
    discoveryDate: linkedFinding.discoveryDate,
    lifecycle: linkedFinding.lifecycle,
  };
}

export function toLinkedFindingRowData(
  finding: RelatedFindingForSignal,
): LinkedFindingRowData {
  return {
    id: finding.id,
    title: finding.title ?? finding.shortDescription ?? null,
    status: finding.status ?? null,
    severity: finding.severity ?? null,
    createdAt: finding.createdAt ?? finding.discoveryDate ?? '',
    discoveryDate: finding.discoveryDate ?? null,
    isArchived: isArchivedEntity(finding),
  };
}
